// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listLineContainerStyles } from "@sc/App/Components/MyListsDetails/ListLineContainer";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

listLineContainerStyles.container = {
    css: css`
        width: 100%;
        padding: 12px 0;
    `,
};

listLineContainerStyles.contentsWrapper = {
    css: css`
        display: flex;
        gap: 20px;
        width: 100%;

        ${xScreen("lte", "xs")} {
            flex-direction: column;
        }
    `,
};

listLineContainerStyles.gridContainer = {
    gap: 0,
};

listLineContainerStyles.descriptionWrapper = {
    width: [12, 12, 6, 6, 6],
};

listLineContainerStyles.actionsWrapper = {
    width: [12, 12, 6, 6, 6],
};

listLineContainerStyles.image = {
    css: css`
        min-width: 120px;
    `,
};

listLineContainerStyles.description = {
    css: css`
        width: 100%;
    `,
};

listLineContainerStyles.deleteItem = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: end;
        ${xScreen("lt", "sm")} {
            margin-bottom: 6px;
        }
    `,
};

listLineContainerStyles.notification = {
    css: css`
        width: 100%;
    `,
};
